import LOG from '../logging/Logger'
import { isProduction, isStaging } from './util/environment'

function getFQDN(service) {
  let fqdn
  if (isProduction()) {
    fqdn = 'https://api.gettingfocused.com/gettingFocused/' + service
  } else if (isStaging()) {
    fqdn = 'https://api.gettingfocused.com/gettingFocused-staging/' + service
  } else {
    fqdn = 'https://api.gettingfocused.com/gettingFocused-dev/' + service
  }
  LOG.info('FQDN: ', fqdn)
  return fqdn
}

export default getFQDN
